const btns = {
  delete: (h, params, vm) => {
    return h('Poptip', {
      props: {
        confirm: true,
        title: '你确定要删除吗?',
        transfer: true
      },
      on: {
        'on-ok': () => {
          vm.$emit('on-rows-delete', params)
        }
      }
    }, [
      h('Button', {
        props: {
          type: 'error'
        },
        style: {
          marginLeft: '5px',
          marginTop: '3px'
        }
      }, [
        '删除'
      ])
    ])
  },
  edit: (h, params, vm) => {
    return h('Button', {
      props: {
        type: 'primary'
      },
      style: {
        marginLeft: '5px',
        marginTop: '3px'
      },
      on: {
        click: () => {
          vm.onEditBtnClick(params)
          vm.$emit('on-rows-edit', params)
        }
      }
    }, [
      '编辑'
    ])
  },
  view: (h, params, vm) => {
    return h('Button', {
      props: {
        type: 'success'
      },
      style: {
        marginLeft: '5px',
        marginTop: '3px'
      },
      on: {
        click: () => {
          vm.$emit('on-rows-view', params)
          vm.onRowsView(params)
        }
      }
    }, [
      '详情'
    ])
  },
  insideDelete: (h, params, vm) => {
    return h('Poptip', {
      props: {
        confirm: true,
        title: '你确定要删除吗?',
        transfer: true
      },
      on: {
        'on-ok': () => {
          if (vm.deleteInsideItem && typeof vm.deleteInsideItem === 'function') {
            vm.deleteInsideItem(params)
          } else {
            console.info('未找到内部按钮的 deleteInsideItem 方法')
          }
        }
      }
    }, [
      h('Button', {
        props: {
          type: 'error'
        },
        style: {
          marginLeft: '5px',
          marginTop: '3px'
        }
      }, [
        '删除'
      ])
    ])
  }
}
export default btns
